const allLocales = {
  global: {
    default: true,
    path: "en",
    locale: "en",
    htmlLang: "en",
    hrefLang: "en",
  },
  en: {
    default: true,
    path: "en",
    locale: "en",
    htmlLang: "en",
    alias: ["en"],
    hrefLang: "en",
  },
  zh: {
    path: "cn-zh",
    locale: "zh",
    htmlLang: "zh",
    alias: ["zh"],
    hrefLang: "zh-cn",
  },
  ja: {
    path: "jp-ja",
    locale: "ja",
    htmlLang: "ja",
    alias: ["ja"],
    hrefLang: "ja-jp",
  },
  kr: {
    path: "kr",
    locale: "kr",
    htmlLang: "kr",
    alias: ["kr"],
    hrefLang: "kr",
  },
  es: {
    path: "es",
    locale: "es",
    htmlLang: "es",
    alias: ["es"],
    hrefLang: "es",
  },
  asia: {
    path: "asia",
    locale: "asia",
    htmlLang: "en",
    hrefLang: "en-asia",
  },
  eu: {
    path: "eu-en",
    locale: "eu",
    htmlLang: "en",
    hrefLang: "en-eu",
  },
  sg_en: {
    path: "sg-en",
    locale: "sg-en",
    htmlLang: "en",
    hrefLang: "en-sg",
  },
  my_en: {
    path: "my-en",
    locale: "my-en",
    htmlLang: "en",
    hrefLang: "en-my",
  },
  th_en: {
    path: "th-en",
    locale: "th-en",
    htmlLang: "en",
    hrefLang: "en-th",
  },
  ph_en: {
    path: "ph-en",
    locale: "ph-en",
    htmlLang: "en",
    hrefLang: "en-ph",
  },
  es_en: {
    path: "es-en",
    locale: "es-en",
    htmlLang: "en",
    hrefLang: "en-es",
  },
  jp_en: {
    path: "jp-en",
    locale: "jp-en",
    htmlLang: "en",
    hrefLang: "en-jp",
  },
  hk_en: {
    path: "hk-en",
    locale: "hk-en",
    htmlLang: "en",
    hrefLang: "en-hk",
  },
  cn_en: {
    path: "cn-en",
    locale: "cn-en",
    htmlLang: "en",
    hrefLang: "en-cn",
  },
  co_en: {
    path: "co-en",
    locale: "co-en",
    htmlLang: "en",
    hrefLang: "en-co",
  },
  ro_en: {
    path: "ro-en",
    locale: "ro-en",
    htmlLang: "en",
    hrefLang: "en-ro",
  },
  in_en: {
    path: "in-en",
    locale: "in-en",
    htmlLang: "en",
    hrefLang: "en-in",
  },
  kr_en: {
    path: "kr-en",
    locale: "kr-en",
    htmlLang: "en",
    hrefLang: "en-kr",
  },
  tr_en: {
    path: "tr-en",
    locale: "tr-en",
    htmlLang: "en",
    hrefLang: "en-tr",
  },
  br_en: {
    path: "br-en",
    locale: "br-en",
    htmlLang: "en",
    hrefLang: "en-br",
  },
  id_en: {
    path: "id-en",
    locale: "id-en",
    htmlLang: "en",
    hrefLang: "en-id",
  },
  vn_en: {
    path: "vn-en",
    locale: "vn-en",
    htmlLang: "en",
    hrefLang: "en-vn",
  },
  us_en: {
    path: "us-en",
    locale: "us-en",
    htmlLang: "en",
    hrefLang: "en-us",
  },
  tw_en: {
    path: "tw-en",
    locale: "tw-en",
    htmlLang: "en",
    hrefLang: "en-tw",
  },
  au_en: {
    path: "au-en",
    locale: "au-en",
    htmlLang: "en",
    hrefLang: "en-au",
  },
};

const stagingLocale = {
  global: {
    default: true,
    path: "en",
    locale: "en",
    htmlLang: "en",
    hrefLang: "en",
  },
  en: {
    default: true,
    path: "en",
    locale: "en",
    htmlLang: "en",
    alias: ["en"],
    hrefLang: "en",
  },
  zh: {
    path: "cn-zh",
    locale: "zh",
    htmlLang: "zh",
    alias: ["zh"],
    hrefLang: "zh-cn",
  },
  // au_en: {
  //   path: "au-en",
  //   locale: "au-en",
  //   htmlLang: "en",
  //   hrefLang: "en-au",
  // },
  // ja: {
  //   path: "jp-ja",
  //   locale: "ja",
  //   htmlLang: "ja",
  //   alias: ["ja"],
  //   hrefLang: "ja-jp",
  // },
  // kr: {
  //   path: "kr",
  //   locale: "kr",
  //   htmlLang: "kr",
  //   alias: ["kr"],
  //   hrefLang: "kr",
  // },
  // es: {
  //   path: "es",
  //   locale: "es",
  //   htmlLang: "es",
  //   alias: ["es"],
  //   hrefLang: "es",
  // },
};

// For tdcx.cn
const chineseOnly = {
  zh: {
    default: true,
    path: "cn-zh",
    locale: "zh",
    htmlLang: "zh",
    hrefLang: "zh-cn",
  },
  global: {
    default: false,
    path: "en",
    locale: "en",
    htmlLang: "en",
    hrefLang: "en",
  },
  en: {
    default: false,
    path: "en",
    locale: "en",
    htmlLang: "en",
    hrefLang: "en",
  },
};

// process.env.GATSBY_ACTIVE_ENV === "production" ||
// process.env.GATSBY_ACTIVE_ENV === "staging"
//   ? process.env.GATSBY_BUILD_SITE === "china"
//     ? console.log("Production environment, will generate chinese version")
//     : console.log("Production environment, will generate all locales")
//   : console.log("Development environment, will generate all locales");

module.exports =
  process.env.GATSBY_ACTIVE_ENV === "production"
    ? process.env.GATSBY_BUILD_SITE === "china"
      ? chineseOnly // Generate Chinese only!
      : allLocales // Generate allLocales only!
    : process.env.GATSBY_BUILD_SITE === "china"
    ? chineseOnly // Generate Chinese only!
    : stagingLocale; // Generate staging locales
